if (!customElements.get('product-calculated-fields')) {
  customElements.define(
    'product-calculated-fields',
    class ProductCalculatedFields extends HTMLElement {
      onVariantChangeUnsubscriber = undefined;
      lengthInput = undefined;
      selectors = {
        lengthInput: '[data-calculated-field="length"]',
        lengthText: '[data-calculated-field="length_text"]',
        unitSelect: '[data-calculated-field="unit_select"]',
        unitText: '[data-calculated-field="unit_text"]',
        finalPrice: '[data-calculated-field="final_price"]',
      };

      constructor() {
        super();
      }

      connectedCallback() {
        this.lengthInput = this.querySelector(this.selectors.lengthInput);
        this.lengthText = this.querySelector(this.selectors.lengthText);
        this.unitSelect = this.querySelector(this.selectors.unitSelect);
        this.unitText = this.querySelector(this.selectors.unitText);
        this.finalPrice = this.querySelector(this.selectors.finalPrice);
        this.$form = document.getElementById(this.formId);

        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));

        this.setFormProperties();

        this.unitSelect.addEventListener('change', (e) => {
          this.unit = e.target.value;
          this.$unitPropertyInput.value = e.target.value;

          this.runCalculateProccess();
        });

        this.lengthInput.addEventListener('input', (e) => {
          if (
            !e.target.value ||
            Number(e.target.value) < e.target.getAttribute('min') ||
            (e.target.getAttribute('max') && Number(e.target.value) > e.target.getAttribute('max'))
          ) {
            this.$form.querySelector('button[type="submit"]').disabled = true;
          } else {
            this.$form.querySelector('button[type="submit"]').disabled = false;
            this.$lengthPropertyInput.value = e.target.value;
            this.$lengthTextPropertyInput.value = this.getLengthFormatted(e.target.value);
          }

          this.calculateWeight();
          this.calculatePrice();
        });

        // this.runCalculateProccess();
      }
      disconnectedCallback() {
        if (onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }

      get settings() {
        return JSON.parse(this.dataset.settings);
      }

      get variantId() {
        return this.dataset.variantId;
      }

      set variantId(value) {
        this.dataset.variantId = value;
      }

      get unit() {
        return this.dataset.unit;
      }

      set unit(value) {
        this.dataset.unit = value;
      }

      get formId() {
        return this.dataset.formId;
      }

      setFormProperties() {
        const pid = this.dataset.productId;
        const setOrCreate = (id, name, value) => {
          let input = document.getElementById(id);
          if (input) {
            input.value = value;
          } else {
            input = document.createElement('input');
            input.type = 'hidden';
            input.id = id;
            input.name = name;
            input.value = value;
            this.$form.appendChild(input);
          }
          return input;
        };

        this.$unitPropertyInput = setOrCreate(
          `rashbel-unit-property-${pid}`,
          'properties[_rashbel_unit]',
          this.unit
        );

        const minLength = this.getMinLength();

        this.$lengthPropertyInput = setOrCreate(
          `rashbel-length-property-${pid}`,
          'properties[_rashbel_length]',
          minLength
        );

        this.$lengthTextPropertyInput = setOrCreate(
          `rashbel-length-text-property-${pid}`,
          `properties[${window.rashbelTranslations.products.product.units['length']}]`,
          this.getLengthFormatted(minLength)
        );

        this.$weightPropertyInput = setOrCreate(
          `rashbel-weight-property-${pid}`,
          'properties[_rashbel_weight_gr]',
          this.getWeightInGrams()
        );

        const estimatedWeightTextProperty = this.getEstimatedWeightTextProperty();

        this.$weightTextPropertyInput = setOrCreate(
          `rashbel-weight-text-property-${pid}`,
          `properties[${estimatedWeightTextProperty.property}]`,
          estimatedWeightTextProperty.value
        );
      }

      handleVariantChange(event) {
        this.variantId = event.data.variant.id.toString();
        this.runCalculateProccess();
      }

      runCalculateProccess() {
        this.setInitialLength();
        this.calculateWeight();
        this.calculatePrice();
        this.setFormProperties();
      }

      calculatePrice() {
        const weight = this.getWeightInGrams(false);
        const basePrice = this.finalPrice.dataset.basePrice;

        const price = parseFloat(weight) * parseFloat(basePrice);
        this.finalPrice.innerText = price.toFixed(2);
      }

      getLengthFormatted(length) {
        let unitText = 'cm' === this.unit ? window.rashbelTranslations.products.product.units.cm : window.rashbelTranslations.products.product.units.in;

        unitText = new DOMParser()
          .parseFromString(unitText, 'text/html')
          .body.textContent;

          return `${length}${unitText}`;
      }

      getMinLength() {
        const variantSettings = window.rashbelProductSettings.variants[this.variantId];
        const length = 'cm' === this.unit ? variantSettings.min_cm : variantSettings.min_inches;

        return length;
      }

      getMaxLength() {
        const variantSettings = window.rashbelProductSettings.variants[this.variantId];
        return 'cm' === this.unit ? variantSettings.max_cm : variantSettings.max_inches;
      }

      setInitialLength() {
        const value = this.getMinLength();
        this.lengthInput.value = value;
        this.lengthInput.setAttribute('min', value);
        this.$lengthPropertyInput.value = value;

        const maxLength = this.getMaxLength();
        if (Number(maxLength) > 0) {
          this.lengthInput.setAttribute('max', maxLength);
        } else {
          this.lengthInput.removeAttribute('max');
        }
        const lengthTranslation =
          'cm' === this.unit ? this.settings.translations.min_length_cm : this.settings.translations.min_length_in;

        this.lengthText.innerText = htmlDecode(lengthTranslation).replace('{{ length }}', value);
      }

      getEstimatedWeightTextProperty() {
        const unitTranslation = this.settings.translations.estimated_weight_g;

        const [beforeWeight, afterWeight] = unitTranslation.split('{{ weight }}');

        return {
          // replace :
          property: String(beforeWeight).replace(/\:/g, '').trim(),
          value:  `${this.getWeightInGrams()}${String(afterWeight).trim()}`.trim(),
        }
      }

      calculateWeight() {
        const unitTranslation = this.settings.translations.estimated_weight_g;
        const weight = this.getWeightInGrams();

        this.unitText.innerText = htmlDecode(unitTranslation).replace('{{ weight }}', weight);

        this.$weightPropertyInput.value = weight;

        this.$weightTextPropertyInput.value = this.getEstimatedWeightTextProperty().value;
      }

      getWeightInGrams(asFixed = true) {
        const gramPerCm = window.rashbelProductSettings.variants[this.variantId].gr_per_cm;
        const currentUnitInCm = 'cm' === this.unit ? this.lengthInput.value : this.lengthInput.value * 2.54;
        const weight = currentUnitInCm * gramPerCm;

        if (!asFixed) {
          return weight;
        }

        return weight.toFixed(3);
      }
    },
  );
}
